export default __webpack_public_path__ + "static/media/Alexanderplatz_2.8e170983.jpg";